import { Component, OnInit, ViewChild, EventEmitter, Output, Input } from '@angular/core';
import { SelectItem } from 'primeng/api/selectitem';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-lazy-loaded-table',
  templateUrl: './lazy-loaded-table.component.html',
  styleUrls: ['./lazy-loaded-table.component.css']
})
export class LazyLoadedTableComponent implements OnInit {
  @Input() loading: boolean = false;
  @Input() data: any[];
  @Input() filterCount: number;
  @Input() metadataTemplateItems: any;
  @Input() rows: any = 50;
  @Input() lazy: any = true;
  @Input() scrollable: any = true;
  @Input() virtualScroll: any = true;
  @Input() columnsChangeRequireApiCall: boolean = true;
  @Input() limitNumCharsEnabled: boolean = true;
  @Input() limitNumChars: number = 60;
  @Input() scrollHeight: any = '74vh'
  @Input()
  set selectedColumns(value) {
    this._selectedColumns = value;
      this.reloadTable();
  }
  @Input()
  set selectedmetadataTemplateItems(value) {
    this._selectedmetadataTemplateItems = value;
    this.selectedmetadataTemplateItemsChange.emit(value);
  }
  @Input()
  set selectedItem(value) {
    this._selectedItem = value;
    this.selectedItemChange.emit(value);
  }

  @Output() onLoadItems: EventEmitter<any> = new EventEmitter();
  @Output() selectedmetadataTemplateItemsChange = new EventEmitter();
  @Output() selectedItemChange = new EventEmitter();

  _selectedmetadataTemplateItems: any[];
  _selectedItem: any = {};
  _columns: any[] = [];
  staticColumns: any[];
  columns: SelectItem[];
  _selectedColumns: any[];
  _currentFilterObject: any;
  @ViewChild('dt', { static: true }) dt: Table;


  advancedFilters: any[] = [];
  constructor() { }

  ngOnInit() {
  }


  get selectedmetadataTemplateItems() {
    return this._selectedmetadataTemplateItems;
  }
  get selectedColumns() {
    return this._selectedColumns;
  }

  get selectedItem() {
    return this._selectedItem;
  }



  reloadTable() {
    if (this.dt) {
      this._currentFilterObject = null;
      
      this.dt.onLazyLoad.emit(this.dt.createLazyLoadMetadata());
    }
  }

  loadItems(event) {
    if (!this.selectedColumns || !event.rows)
      return;


    let filterArr = new Array();
    if (event.filters) {
      for (let key in event.filters) {
        filterArr.push({ key: key, value: event.filters[key].value })
      }
    }
    let filterObject = {
      StartCount: event.first,
      PageSize: event.rows,
      Filters: filterArr,
      Sort: { key: event.sortField, Type: event.sortOrder },
      SelectedColumns: this.selectedColumns.filter(col => col.dynamicControl === true).map(({ field }) => field)
    };
    if (this._currentFilterObject && this._currentFilterObject == JSON.stringify(filterObject)) {
      return;
    }

    this._currentFilterObject = JSON.stringify(filterObject);
    this.onLoadItems.emit(filterObject);
  }

  limitNumberOfChars(val: string) {
    if (!this.limitNumCharsEnabled)
      return val;
    if (val && val.length > this.limitNumChars)
      return val.substring(0, this.limitNumChars) + "...";
    else return val;
  }

  
}
